import { MessageCircleHeart } from "lucide-react";
import BlockList from "../BlockList";

/**
 * Master v5 Prompt 9 — Reflection renderer. Block-based (long_text),
 * the closing-the-loop surface. A dedicated Reflection record (§
 * practice_contracts.Reflection) can additionally be attached to the
 * submitted attempt from RoomShell's own "Add a reflection" affordance
 * — this renderer's block content and a Reflection row are deliberately
 * two different things (one is the exercise body, one is a follow-up
 * note), never conflated.
 */
export default function ReflectionRenderer({ workspaceId, docId, instructions, isViewAsClient, isInstanceLocked }) {
  return (
    <div data-testid="renderer-reflection">
      <div className="flex items-center gap-2 text-ink-soft mb-3">
        <MessageCircleHeart size={16} /><span className="text-sm uppercase tracking-wide">Reflection</span>
      </div>
      {instructions && <p className="text-ink-soft text-sm mb-4" data-testid="renderer-reflection-instructions">{instructions}</p>}
      <BlockList workspaceId={workspaceId} docId={docId} isViewAsClient={isViewAsClient} isInstanceLocked={isInstanceLocked} />
    </div>
  );
}
